import { render, staticRenderFns } from "./lottie-image.vue?vue&type=template&id=7b06d91a&scoped=true"
import script from "./lottie-image.vue?vue&type=script&lang=ts"
export * from "./lottie-image.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b06d91a",
  null
  
)

export default component.exports